import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { usePostCalculatorMysteryShopperMutation } from "../../../../services/apiSlice";
import images from "../../../../images";
import { useTranslation } from "react-i18next";
import LoadingCommon from "../../../../components/common/LoadingStatus/LoadingCommon";

const MysteryShopperCalculator = () => {
  const { t } = useTranslation();
  const [shopperCount, setShopperCount] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  const {
    custom_segmentations = [],
    segmentationDataRedux = [],
    qualifyingQuestionsData = [],
  } = useSelector((state) => state.filters || {});

  const [postCalculatorMysteryShoppers, { isLoading }] =
    usePostCalculatorMysteryShopperMutation();

  useEffect(() => {
    const calculateShoppers = async () => {
      if (!custom_segmentations.length) {
        setShopperCount(0);
        setIsLoaded(true);
        return;
      }

      try {
        const systemSegmentations = [];
        const customSegmentations = [];

        custom_segmentations.forEach((segment) => {
          const originalSegment = segmentationDataRedux.find(
            (s) => s.id === segment.id
          );

          const checkedOptions = segment.options
            .filter((opt) => opt.checked)
            .map((opt) => ({
              min_value: opt.min_value || 0,
              max_value: opt.max_value || 0,
              value: opt.value || "",
              title: opt.title || "",
              description: opt.description || "",
            }));

          const hasChanges = segment.options.some(
            (opt) => opt.checked !== true
          );

          if (hasChanges && segment.consumer_map_field !== "custom") {
            if (checkedOptions.length > 0) {
              customSegmentations.push({
                name: segment.name,
                type: segment.type || "enum",
                description: segment.description || "",
                category: segment.category || "",
                consumer_map_field: segment.consumer_map_field,
                options: checkedOptions,
              });
            }
          } else if (originalSegment) {
            systemSegmentations.push(segment.id);
          }
        });
        qualifyingQuestionsData.forEach((segment) => {
          const hasCheckedOptions = segment.options.some((opt) => opt.checked);
          if (hasCheckedOptions) {
            customSegmentations.push({
              name: segment.name,
              type: segment.type || "enum",
              description: segment.description || "",
              category: segment.category || "custom",
              consumer_map_field: null,
              options: segment.options
                .filter((opt) => opt.checked)
                .map((opt) => ({
                  min_value: opt.min_value || 0,
                  max_value: opt.max_value || 0,
                  value: opt.value || "",
                  title: opt.title || "",
                  description: opt.description || "",
                })),
            });
          }
        });
        if (
          systemSegmentations.length === 0 &&
          customSegmentations.length === 0
        ) {
          setShopperCount(0);
          setIsLoaded(true);
          return;
        }
        const payload = {
          system_segmentations: systemSegmentations,
          custom_segmentations: customSegmentations,
        };

        const response = await postCalculatorMysteryShoppers(payload).unwrap();

        if (response.status === 200 && response.data) {
          setShopperCount(response.data.mysteryshopper);
        } else {
          setShopperCount(20);
          console.warn("API did not return mystery shopper count");
        }
      } catch (error) {
        console.error("Error calculating mystery shoppers:", error);
        setShopperCount(20);
      } finally {
        setIsLoaded(true);
      }
    };

    calculateShoppers();
  }, [
    custom_segmentations,
    segmentationDataRedux,
    qualifyingQuestionsData,
    postCalculatorMysteryShoppers,
  ]);

  if (!isLoaded && isLoading) {
    return <LoadingCommon statusLoading={true} />;
  }

  return (
    <div className="flex flex-col gap-2 justify-center items-center p-3 w-full bg-white rounded-xl border border-solid border-stone-200">
      <div className="flex flex-row justify-between w-full">
        <p className="text-sm text-neutral-500">{t("quest.mysteryShoppers")}</p>
        <img src={images.InfoCircleIcon} alt="" className="w-[22px]" />
      </div>
      <div className="flex flex-row justify-between w-full">
        <p className="text-2xl font-medium text-zinc-800">{shopperCount}</p>
        <div></div>
      </div>
    </div>
  );
};

export default MysteryShopperCalculator;
